import { GzDialogWebComponent } from '../../../ui/gzDialog';
import { GzDialog } from '../../../ui/gzDialog/component/GzDialog';
import { attachDialogFooterListeners, getProceedDialogButtons } from '../shared/dialogUtils';

export class AddExclusionsDialog {
  static open(translateFn: Function, numberOfSelectedItems: number): GzDialogWebComponent {
    const dialogBody = document.createElement('div');
    dialogBody.innerHTML = `<p>${translateFn('Are you sure you want to exclude the selected items?')}</p>`;
    const footerContent = getProceedDialogButtons(translateFn, 'Confirm');
    const dialogConfigs: GzDialog = {
      headline: translateFn('Confirm'),
      bodyContent: dialogBody,
      isOpen: true,
      footerContent,
    };

    const dialog = GzDialogWebComponent.buildDialogElement(dialogConfigs);

    attachDialogFooterListeners(footerContent, dialog);

    return dialog;
  }
}
